import { takeEvery, put } from 'redux-saga/effects';
import notificationActions from './actions';
import NOTIFICATION_TYPES from './types';

function* clear() {
	yield put(notificationActions.clean());
}

export default function* index() {
	yield takeEvery(NOTIFICATION_TYPES.ADD, clear);
}
